<div class="container">
  <div class="title-row">
    <h3 class="klabel-huge">Filter by Category</h3>
    <app-button
      [text]="'De-select all'"
      class="grey"
      (click)="clearCategoriesFilter()"
    ></app-button>
  </div>
  <div class="content">
    <div class="section">
      <h4 class="section-title">Category Selection</h4>

      <div class="checkbox-group">
        <div class="checkbox-item" *ngIf="categoryList.length !== 0">
          <input
            type="checkbox"
            class="kinput"
            [checked]="
              categoryList.length === mainFilter.categories.length &&
              categoryList.length !== 0
            "
            (change)="selectAllCategoriesFilter($event)"
            id="selectAllCategories"
          />
          <label for="selectAllCategories" class="checkbox-label">
            Select all categories
            <mat-icon class="checkbox-icon" matTooltip="Select or deselect all categories at once" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>

        <div class="checkbox-item" *ngFor="let category of categoryList">
          <input
            type="checkbox"
            class="kinput"
            [checked]="checkIncludesCategory(category)"
            (change)="updateCheckboxFilter($event, category)"
            [id]="'category-' + category?.category"
          />
          <label [for]="'category-' + category?.category" class="checkbox-label">
            {{ category?.category }}
            <mat-icon class="checkbox-icon" [matTooltip]="getCategoryHelpText(category)" matTooltipPosition="above">help_outline</mat-icon>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
